import { useEffect, useMemo } from 'react';
import { useSnapshot } from 'valtio';
import { TacticMode, TacticStatus, Channel } from 'basics/enums/maya.enums';
import useGetAllTacticsQuery from 'basics/graphql/queries/getAllTactics';
import { CepStateType } from 'basics/types/maya.types';
import { Tactic } from 'generated/maya.types';
import cepState from 'states/cep.states';
import tacticState from 'states/tactic.states';

const useTacticKanbanView = () => {
  const cepStateValue = useSnapshot(cepState) as CepStateType;
  const cepId = cepStateValue.cep?._id;

  const queryFilters = useMemo(
    () => ({
      cep: cepId,
      status: [TacticStatus.EMPTY, TacticStatus.DRAFT, TacticStatus.APPROVED],
      channel: Object.values(Channel).filter((channel) => channel !== Channel.group),
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [cepId],
  );

  const { data, loading } = useGetAllTacticsQuery(undefined, queryFilters);

  useEffect(() => {
    tacticState.mode = TacticMode.list;
  }, []);

  useEffect(() => {
    if (!loading) {
      cepState.tactics = data;
    }
  }, [data, loading]);

  type TacticActionOrderGroup = {
    [actionOrder: string]: Tactic[];
  };

  const groupedTactics: TacticActionOrderGroup = {};
  cepStateValue.tactics.forEach((tactic) => {
    const actionOrder = tactic?.actionOrder;

    if (actionOrder) {
      if (groupedTactics[actionOrder] === undefined) {
        groupedTactics[actionOrder] = [tactic];
      } else {
        groupedTactics[actionOrder].push(tactic);
      }
    }
  });

  return {
    groupedTactics,
  };
};

export default useTacticKanbanView;
